const getScoreColor = (percent) => {
    const safePercent = Number(percent || 0);
    if (safePercent > 70) return "#22b95d";
    if (safePercent >= 40) return "#f59b10";
    return "#f4474d";
};

export default getScoreColor;
